import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ec20975")

_pushScopeId("data-v-0ec20975")
const _hoisted_1 = { class: "planification-guide" }
const _hoisted_2 = { class: "indicator-label" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "bi bi-arrow-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "d-flex flex-column bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/illustrations/progress-hd.png')","background-color":"#597dfe !important"}
}, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-9" }, [
    /*#__PURE__*/_createVNode("h2", { class: "text-light mb-6" }, "Planification Guide"),
    /*#__PURE__*/_createVNode("h4", { class: "text-light text-normal text-center" }, " Con la guía de planificación y el software de gestión de objetivos EGG OKR, podrás ejecutar y lograr los objetivos estratégicos junto a tu equipo, aumentando las capacidades y competencias, trimestre a trimestre, para que tu empresa sea increíble. ")
  ]),
  /*#__PURE__*/_createVNode("h3", { class: "text-left px-9 text-white" }, " Esta guía contiene 6 videos divididos del siguiente modo: "),
  /*#__PURE__*/_createVNode("div", { class: "d-flex mb-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-5 col fs-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box p-9" }, [
        /*#__PURE__*/_createTextVNode(" Introducción a OKR donde conocerás qué es OKR y de dónde viene. "),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createVNode("ul", null, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("b", null, "Paso 1"),
            /*#__PURE__*/_createTextVNode(": Establecer el OMI u objetivo de mayor impacto para el trimestre. ")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("b", null, "Paso 2"),
            /*#__PURE__*/_createTextVNode(": Crear los sub-objetivos u objetivos específicos del OMI. ")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("b", null, "Paso 3"),
            /*#__PURE__*/_createTextVNode(": Definir los resultados clave - KR para cada uno de los sub-objetivos. ")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("b", null, "Paso 4"),
            /*#__PURE__*/_createTextVNode(": Ejecutar donde te prepararás para ejecutar y lograr tus objetivos. ")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createVNode("b", null, "Comenzando en 10 pasos con EGG OKR"),
            /*#__PURE__*/_createTextVNode(" donde aprenderás a usar EGG OKR. ")
          ])
        ]),
        /*#__PURE__*/_createTextVNode(" Para obtener el mayor provecho de esta guía, reúnete con tu equipo de trabajo para ver cada uno de los videos, completando las actividades que en cada uno de ellos se describen. "),
        /*#__PURE__*/_createVNode("div", { class: "my-6" }, [
          /*#__PURE__*/_createVNode("b", null, "EGG OKR y la Guía de planificación son completamente gratis y sin límites.")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-7 col text-center" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box" }, [
        /*#__PURE__*/_createVNode("iframe", {
          height: "330",
          src: "https://www.youtube.com/embed/tqX1HND2FJs",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
          class: "embedded_iframe"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "d-flex mb-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-4 col fs-5" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box" }, [
        /*#__PURE__*/_createVNode("iframe", {
          height: "199",
          src: "https://www.youtube.com/embed/hoxgYLr2lWk",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
          class: "embedded_iframe"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-4 col fs-5" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box" }, [
        /*#__PURE__*/_createVNode("iframe", {
          height: "199",
          src: "https://www.youtube.com/embed/lC9rqStU4Rg",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
          class: "embedded_iframe"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-4 col fs-5" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box" }, [
        /*#__PURE__*/_createVNode("iframe", {
          height: "199",
          src: "https://www.youtube.com/embed/L_FPRV9eCvo",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
          class: "embedded_iframe"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "d-flex mb-6" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-4 col fs-5" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box" }, [
        /*#__PURE__*/_createVNode("iframe", {
          height: "199",
          src: "https://www.youtube.com/embed/9MqMPgpz17I",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
          class: "embedded_iframe"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-4 col fs-5" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box" }, [
        /*#__PURE__*/_createVNode("iframe", {
          height: "199",
          src: "https://www.youtube.com/embed/QSUXKVWuT0w",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
          class: "embedded_iframe"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-lg-4 col fs-5" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-box" }, [
        /*#__PURE__*/_createVNode("iframe", {
          height: "199",
          src: "https://www.youtube.com/embed/Q4CS3kkFVmw",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "",
          class: "embedded_iframe"
        })
      ])
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      type: "button",
      id: "back_button",
      class: "btn btn-light btn-back",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _createVNode("span", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.translate("goBack")), 1)
      ])
    ]),
    _hoisted_4
  ]))
})